<p class="header-description">
  <ng-content></ng-content>
</p>
